import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import { auth } from '@/core/store/auth';
import { general } from '@/core/store/general';
import { client } from '@/manager/client/store';
import { employee } from '@/manager/employee/store';
import { convocation } from '@/manager/convocation/store';
import { payment } from '@/manager/payment/store';
import { product } from '@/manager/product/store';
import { purchase } from '@/clickbuy/purchase/store';
import { sync } from '@/manager/sync/store';
import { billing } from '@/manager/billing/store';
import { business } from '@/manager/business/store';

Vue.use(Vuex);

const store: StoreOptions<any> = {
  modules: {
    auth,
    billing,
    business,
    client,
    convocation,
    employee,
    general,
    payment,
    product,
    purchase,
    sync,
  },
};

export default new Vuex.Store<any>(store);

